export const routeStates = {
  INPROCESS: 0,
  WAREHOUSE: 1,
  CUSTOMSENTRYREGISTRATION: 2,
  CUSTOMSEXITREGISTRATION: 3,
  INCUSTOMSREGISTRATION: 4,
  ARRIVEDTOWAREHOUSE: 5,
  UNLOADING: 6,
  UNLOADED: 7,
};
